<!-- 收藏弹框 -->
<template>
    <div class="co-dialog" v-show="isDialogShow" @click="closeDialog">
        <div class="co-model" @click.stop v-show="dialogType==1">
            <h3 class="mo-title">
                <span v-if="type==1">收藏</span>
                <span v-if="type==2">编辑收藏</span>
                <span class="mo-close" @click="closeDialog">×</span>
            </h3>
            <div class="mo-content">
                <div class="ct-box clearfix">
                    <div class="fl ct-left">
                        <img :src="fileCoverImg" alt="" class="co-img">
                        <p v-if="type==2" class="delete" @click="dialogType=2">取消收藏</p>
                    </div>
                    <div class="fr ct-right">
                        <input type="text" placeholder="创建收藏夹,按enter键创建" v-model="collectName" class="ct-input" maxlength="13" @keyup="createFolder" />
                        <ul class="ct-list" v-if="collectList && collectList.length>0">
                            <li v-for="(item,index) in collectList" :key="index" class="clearfix" :class="{active: nowIndex==index}" :id="item.Id" @click="collect(item.Id,index,item.Name)">
                                <div class="fl ct-title" :title="item.Name">{{item.Name}}</div>
                                <div class="fr ct-collect">
                                    <span v-if="type==1">收藏</span>
                                    <span v-if="type==2">更改</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="df mo-handel">
                <div class="mo-btn btn-sure" @click="verifyResult">保存</div>
                <div class="mo-btn btn-cancel" @click="closeDialog">取消</div>
            </div>
        </div>
         <div class="co-model" @click.stop v-show="dialogType==2">
            <h3 class="mo-title">取消确认
                <span class="mo-close" @click="closeDialog">×</span>
            </h3>
            <div class="mo-content">
                <div class="mo-item mo-warn-box">
                    <span class="mo-warn">!</span>
                    <span>取消收藏后不能恢复，确定要取消吗？</span>
                </div>
            </div>
            <div class="df mo-handel">
                <div class="mo-btn btn-sure" @click="verifyResult">确定</div>
                <div class="mo-btn btn-cancel" @click="closeDialog">取消</div>
            </div>
        </div>
        <warn ref="warn"></warn>
    </div>
</template>
<script>
import { getCollectList, addOrUpdateCollect,collectFile,updateCollectFile,cancelCollect,updateCoverimg } from "@/assets/js/modules/userApi"
import {getToken} from "@/assets/js/modules/auth"
import Warn from "../common/warn"
export default {
    inject: ['reload'],
    props: {
        isDialogShow: {
            type: Boolean,
            default: false
        },
        userId: {   //用户Id
            
        },
        fileId: {       //文章或文件Id
           
        },
        sourceId: {     //文章或文件综合Id

        },
        fileCoverImg: { //文章封面图
            type: String,
            default: ""
        },
        type: {         //类型  1--收藏 2--编辑
            type: Number,
            default: 1
        },
        sourceType: {   //类型, 文件--1; 文章--2
            type: Number
        }
    },
    components: {
        Warn
    },
    data() {
        return {
            collectList: [],
            collectName: "",
            nowIndex: 0,   //当前选中li的下标
            FavoritesId: "",    //收藏夹Id
            isDeleteConfirm: true,
            dialogType: 1,      //弹框类型 1--收藏, 2--取消确认   
        }
    },
    created() {
        if(getToken()){
            this.getCollectList();
        }
    },
    methods: {
        //保存结果
        verifyResult() {
            if(this.collectList.length==0){
                this.$refs.warn.message("请先创建收藏夹,输入名称,按Enter键创建。");
                return;
            }
            switch(this.dialogType){
                case 1: 
                    switch(this.type){
                        case 1: 
                            this.collectFile();
                            break;
                        case 2:
                            this.updateCollectFile();
                            break;
                    }
                    break;
                case 2: 
                    // console.log(this.fileId);
                    this.cancelCollect();
                    break;
            }
            
        },
        //收藏文件
        collectFile(){
            let data = {
                SourceID: this.fileId,
                UserID: this.userId,
                SourceType: this.sourceType,
                Type: 2,    //2--收藏
                FavoritesId: this.FavoritesId
            };
            collectFile(data).then(res=>{
                if(res.data.Success){
                    this.$emit('closeCollectDialog',{text:"收藏成功!",flag: true});
                    if(!this.collectList[this.nowIndex].CoverImg){
                        this.setCoverImg(res.data.Data.Id);
                    }
                }
            })
        },
        //设置封面图
        setCoverImg(id){
            if(!id) return;
            let data = {
                Id: this.FavoritesId,             //收藏夹ID
                FavoritesId: id
            };
            updateCoverimg(data).then(res=>{
                if(res.data.Success){

                }
            })
        },
        //更新文件到指定收藏夹
        updateCollectFile(){
            let data = {
                FileComprehensiveId: this.fileId,
                NewFavoritesId: this.FavoritesId
            };
            updateCollectFile(data).then(res=>{
                if(res.data.Success){
                    this.$emit('closeCollectDialog',{text:"更改成功!",flag: true});
                    if(!this.collectList[this.nowIndex].CoverImg){
                        this.setCoverImg(this.fileId);
                    }
                    this.reload();
                }
            })
        },
        //取消收藏
        cancelCollect(){
            let data = {
                UserId: this.userId,
                FileComprehensiveId: this.fileId
            };
            cancelCollect(data).then(res=>{
                if(res.data.Success){
                    this.$emit('closeCollectDialog',{text:"取消收藏成功!",flag: true});
                    this.reload();
                }
            })
        },
        closeDialog() {
            this.dialogType = 1;
            this.$emit('closeCollectDialog');
        },
        //创建收藏夹
        createFolder(e) {
            let keyCode = e.keyCode;
            if (keyCode == 13 && this.collectName != "") {
                if (!this.justifyCollectName(this.collectName)) {
                    this.$refs.warn.message("已有同名文件夹!");
                    return;
                }
                //创建收藏夹,添加至我的收藏夹中
                let data = {
                    Id: "",
                    Name: this.collectName,
                    UserId: this.userId,
                    Sort: "0"
                };
                addOrUpdateCollect(data).then(res => {
                    if (res.data.Success) {
                        let result = res.data.Data;
                        result.TotalCount = 0;
                        this.collectList.push(result);
                        //创建之后默认选择创建后的那一个
                        this.nowIndex = this.collectList.length-1;
                        this.FavoritesId = result.Id;
                    }
                })
            }
        },
        closeWarn() {
            this.$refs.warn.closeWarn();
        },
        //获取收藏夹列表
        getCollectList() {
            let data = {
                "UserID": this.userId,
                "SkipCount": 0,
                "MaxResultCount": 999
            };
            getCollectList(data).then(res => {
                if (res.data.Success) {
                    this.collectList = res.data.Data.Items;
                    this.FavoritesId = this.collectList[this.nowIndex] ? this.collectList[this.nowIndex].Id: "";
                    this.collectName = this.collectList[this.nowIndex] ? this.collectList[this.nowIndex].Name : "";
                }
            })
        },
        //验证是否有同名收藏夹
        justifyCollectName(name) {
            let list = this.collectList;
            for (var i = 0; i < list.length; i++) {
                if (list[i].Name === name) {
                    return false;
                }
            }
            return true;
        },
        //选择收藏夹
        collect(id,index,name){
            this.FavoritesId = id;
            this.nowIndex = index;
            this.collectName = name;
        }
    }
}
</script>
<style scoped>
.co-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    z-index: 99;
}

.co-model {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 620px;
    padding-bottom: 40px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
}

.mo-title {
    line-height: 80px;
    height: 80px;
    font-size: 18px;
    color: #333;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #e7e7e7;
}

.mo-close {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 40px;
    line-height: 1;
    color: #999;
    cursor: pointer;
}

.mo-close:hover {
    color: #666;
}

.mo-content {
    padding: 40px 0;
}
.mo-warn-box {
  display: flex;
  justify-content: center;
  line-height: 48px;
  font-size: 16px;
}

.mo-warn {
  font-size: 42px;
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  text-align: center;
  line-height: 48px;
  margin-right: 20px;
}

.ct-box {
    padding: 0 30px;
}

.ct-left {
    width: 250px;
    height: 250px;
    position: relative;
}

.ct-left img {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #fbfbfb;
    object-fit: cover;
}
.ct-left .delete{
    position: absolute;
    left: 0;
    bottom: -30px;
    font-size: 14px;
    cursor: pointer;
}
.ct-left .delete:hover{
    color: #ff9966;
}

.ct-right {
    width: 287px;
    font-size: 14px;
    color: #999;
}

.ct-input {
    width: 100%;
    line-height: 40px;
    height: 40px;
    padding-left: 20px;
    border: 1px solid #e7e7e7;
    background-color: #f8f8f8;
    box-sizing: border-box;
    border-radius: 5px;
}

.ct-list {
    line-height: 34px;
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 10px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}

.ct-list::-webkit-scrollbar {
    width: 10px;
    background-color: #fbfbfb;
}

.ct-list::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #fbfbfb;
}

.ct-list::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #e7e7e7;
}

.ct-list li {
    padding: 0 5px 0 20px;
    border-radius: 5px;
}

.ct-list .ct-title {
    width: 196px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ct-list .ct-collect {
    width: 50px;
    text-align: center;
    height: 20px;
    line-height: 20px;
    background-color: #ff9933;
    color: #fff;
    margin-top: 7px;
    border-radius: 10px;
    cursor: pointer;
    display: none;
}

.ct-list li:hover, .ct-list li.active{
    background-color: #f8f8f8;
}

.ct-list li:hover .ct-collect {
    display: block;
}

.mo-handel {
    justify-content: center;
    text-align: center;
}

.mo-btn {
    width: 150px;
    height: 40px;
    line-height: 38px;
    border-radius: 20px;
    box-sizing: border-box;
    border: 1px solid #ff9933;
    cursor: pointer;
}

.btn-sure {
    background-color: #ff9933;
    color: #fff;
    margin-right: 30px;
}

.btn-sure:hover {
    background-color: #ff8833;
}

.btn-cancel {
    color: #999;
}

.btn-cancel:hover {
    background-color: #fbfbfb;
}
</style>



// WEBPACK FOOTER //
// src/components/common/collect.vue